exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "input:invalid {\n    outline: solid red;\n}\n\ninput:valid {\n    outline: none black;\n}", ""]);

// exports
